function accordionPanelLiveRegion(detailsEl) {
  const section = detailsEl?.closest('section');
  let live = section?.querySelector('.deep-dive-accordion__live, .accordion-details__live');
  if (live) return live;

  const parent = detailsEl?.parentElement;
  live = parent?.querySelector('.deep-dive-accordion__live, .accordion-details__live');
  return live || null;
}

function accordionPanelReadableText(panel) {
  const raw = panel.innerText ?? panel.textContent ?? '';
  return raw.replace(/\s+/g, ' ').trim();
}

function announceAccordionPanel(detailsEl, panel) {
  const text = accordionPanelReadableText(panel);
  if (!text) return;

  const live = accordionPanelLiveRegion(detailsEl);
  if (!live) return;

  live.textContent = '';
  requestAnimationFrame(() => {
    live.textContent = text;
  });
}

export function syncAccordionDetailsPanelAccessibility(
  panel,
  { collapsed, announceOnExpand = false, detailsEl = null } = {},
) {
  if (!panel) return;

  panel.setAttribute('aria-hidden', collapsed ? 'true' : 'false');

  const live = detailsEl ? accordionPanelLiveRegion(detailsEl) : null;
  if (collapsed) {
    if (live) live.textContent = '';
    return;
  }

  if (announceOnExpand && detailsEl) {
    announceAccordionPanel(detailsEl, panel);
  }
}

export function syncAccordionDetailsSummaryAccessibility(summary, expanded) {
  if (!summary) return;

  summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}

export function bindAccordionDetailsAccessibility(detailsEl) {
  const summary = detailsEl?.querySelector('summary');
  const panel = detailsEl?.querySelector('[role="region"]');
  if (!summary || !panel) return () => {};

  const onToggle = () => {
    const expanded = detailsEl.open;
    syncAccordionDetailsSummaryAccessibility(summary, expanded);
    syncAccordionDetailsPanelAccessibility(panel, {
      collapsed: !expanded,
      announceOnExpand: expanded,
      detailsEl,
    });
  };

  detailsEl.addEventListener('toggle', onToggle);
  onToggle();

  return () => detailsEl.removeEventListener('toggle', onToggle);
}
